import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { cn } from '@/lib/utils';

interface LogoProps extends React.HTMLAttributes<HTMLSpanElement> {
  href?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
  className?: string;
  size?: number;
  height?: number;
  width?: number;
  /** Full wordmark vs compact mark (`initial.svg`; e.g. collapsed sidebar). */
  variant?: 'wordmark' | 'mark';
}

export const Logo: React.FC<LogoProps> = ({
  href,
  onClick,
  className = '',
  size = 28,
  height,
  width,
  variant = 'wordmark',
  ...props
}) => {
  const isMark = variant === 'mark';
  const logo = isMark ? '/initial.svg' : '/wordmark.svg';
  const w = width ?? (isMark ? 24 : 100);
  const h = height ?? (isMark ? 24 : 32);

  const imgClass = cn('object-contain transition-none', isMark && 'h-6 w-6 shrink-0');

  if (href) {
    return (
      <Link
        href={href}
        className={cn(isMark && 'inline-flex items-center justify-center', className)}
        prefetch={href === '/' ? false : undefined}
        {...props}
      >
        <Image src={logo} alt="Atrium" width={w} height={h} className={imgClass} priority />
      </Link>
    );
  }

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(isMark && 'inline-flex items-center justify-center', className)}
        style={{ background: 'none', border: 'none', padding: 0 }}
        {...props}
      >
        <Image src={logo} alt="Atrium" width={w} height={h} className={imgClass} priority />
      </button>
    );
  }

  return (
    <span className={cn(isMark && 'inline-flex items-center justify-center', className)} {...props}>
      <Image src={logo} alt="Atrium" width={w} height={h} className={imgClass} priority />
    </span>
  );
}; 
